

























































import {
  Component,
  Vue, Watch,
} from 'vue-property-decorator';
import {Getter} from 'vuex-class';
@Component({
  components: {

  },
})
export default class OrganisationSettings extends Vue {
  @Getter private activeOrganisation!: any;
  @Getter private hasPermission: any;
  private activeIndex: number | null = null;
  private activeList: any[] = [];
  private clicked: any = {};

  private menuItems: any[] = [
    { name: 'General', items: [
        { id: 0, title: 'Organisation Details', path: 'organisationdetails' },
      ],
    },
    { name: 'User Management', items: [
        { id: 1,  title: 'Users', path: 'users'},
        { id: 2,  title: 'API Keys', path: 'apiKeys' },
      ],
    },
  ];

  @Watch('$route.path', {immediate: true})
  private onRouteChange() {
    this.getSelected();
  }

  private mounted() {
    this.getSelected();
  }

  private getSelected() {
    const activeList = this.menuItems.filter((menu: any) => {
      if (menu.items.some((m: any) => this.$route.name!.includes(m.path.toString()))) {
        return menu;
      }
    });
    this.activeList = activeList[0].items;
    this.clicked = this.activeList.find((a: any) => this.$route.name!.includes(a.path.toString()));
    this.activeIndex = this.clicked.id;
  }
}
